import { render, staticRenderFns } from "./MediaDialog.vue?vue&type=template&id=27ee3b52&scoped=true"
import script from "./MediaDialog.vue?vue&type=script&lang=js"
export * from "./MediaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee3b52",
  null
  
)

export default component.exports